/**
 * Composing a new email or replying to a thread from Cortado sends from a
 * connected inbox (the EmailInbox add-on): the mailbox picked in the "From"
 * select, else the sender's own, else the organization's default.
 * Organizations without the add-on see {@link EMAIL_COMPOSE_NEEDS_INBOX_MESSAGE}
 * instead. Automated/system mail (quote sent, invoices, …) is unaffected.
 */
export const EMAIL_COMPOSE_NEEDS_INBOX_MESSAGE =
  'Sending email from Cortado needs a connected inbox.'

export const EMAIL_COMPOSE_NO_MAILBOX_MESSAGE =
  'Connect an inbox in Settings → Email to send email from Cortado.'

export const EMAIL_COMPOSE_SENDERS_LOAD_ERROR_MESSAGE =
  "Couldn't load your connected inboxes. Close this and try again."
